import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import Img from 'react-image';
import { FrameContainer, FixedWidthContainer } from '../../styledComponents/layout';
import { DownloadButtonWrapper } from '../../styledComponents/theme'
import AdSense from 'react-adsense';
export const BrandWrapper = styled.div`
background-image: url("/img/app_download_background.png");
display: flex;
background-size: contain;
`;
const BrandImageWrapper = styled.div`
width: 100%;
max-width: 600px;
margin: 0 auto;
`

const Container = styled(FrameContainer)`
  display: flex;
  flex-direction: column;
  align-content: center;
`;

const BrandCopy = styled.p`
color: #ffffff;
font-size: 1.4em;
text-align: center;
font-weight: bold;
margin: 2% 1%;
`;
const BrandSummary = styled.p`
color: #ffffff;
font-size: 1em;
text-align: center;
margin: 4% 1%;
`;
const BrandTitle = styled.p`
color: #ffffff;
font-size: 1.2em;
text-align: center;
margin: 2% 1% ;
font-weight: bold;
`;
const FooterMenuWrapper = styled.div`
display: flex;
justify-content: space-evenly;
`;

const CopyrightWrapper = styled.div`
display: flex;
justify-content: space-evenly;
align-content: center;
align-items: start;
flex-wrap: wrap;
`;
const Copyright = styled.div`
display:flex;
flex-direction: column;
justify-content: center;
text-align: center;
`;
const CopyrightImage = styled(Img)`
max-height: 48px;

`;
const CopyrightText = styled.p`
  font-size: 1.2rem;
  color: #999999;
`;

export const Brand = (data) => {
  return (
    <BrandWrapper>
      <Container>
        <BrandImageWrapper>
          <img src="/img/app_download_img.png" alt={"Flick!On!TV アプリ 無料"}/>
        </BrandImageWrapper>
        <BrandCopy>ファンの観たいを<br className="sp"/>ファンとつくる番組メディア</BrandCopy>
        <BrandTitle>Flick!On!TV（フリックオンＴV）<br className="sp"/>公式アプリ</BrandTitle>
        <BrandSummary>Flick!On!TVのアプリなら、<br className="sp"/>お気に入り保存などの便利な機能の他、<br/>WEBで配信終了となったあの番組も続々配信中！</BrandSummary>
        <DownloadButtonWrapper>
          <a
            href={data.site.siteMetadata.firebaseDynamicLink}>
            <img src="/img/app_download.png" alt={"アプリダウンロードはこちら"}/>
          </a>
        </DownloadButtonWrapper>
      </Container>
    </BrandWrapper>
  );
}
export const FooterMenu = () => {
  return (
    <Container>
      <FooterMenuWrapper>
        <ul>
          <li><Link to={"/terms"} className="t28">利用規約</Link></li>
        </ul>
        <ul>
          <li><Link to="/privacy" className="t28">プライバシーポリシー</Link></li>
          <li><Link to="/law" className="t28">特定商取引法の表示</Link></li>
        </ul>
        <ul>
          <li><a href="https://www.abasaku.co.jp/" target="_blank" className="t28">運営会社</a></li>
          <li><a href="https://form.run/@abasaku-6809" target="_blank" className="t28">お問い合わせ</a></li>
        </ul>
      </FooterMenuWrapper>
    </Container>
  );

}
export const Copyrights = () => {
  return (
    <Container>
      <hr/>
      <CopyrightWrapper>
        <Copyright>
          <div><a href="https://www.abasaku.co.jp"><CopyrightImage src={"/img/abasaku_logo.png"} alt="abasaku"/></a></div>
          <CopyrightText>ⓒ 2019 abasaku Inc.</CopyrightText>
        </Copyright>
        <Copyright>
          <div><CopyrightImage src={"/img/jasrac.jpg"} alt={"jasrac"}/></div>
          <CopyrightText>JASRAC許諾: <br className="sp"/>第9021335002Y45040号​</CopyrightText>
        </Copyright>
      </CopyrightWrapper>
    </Container>
  );
}


const Footer = (props) => {
  return(
    <footer>
      <Container>
        <AdSense.Google
          client="ca-pub-5117998698905177"
          slot="7713083073"
          format="auto"
          full-width-responsive="true"
        />
      </Container>
      <Brand {...props.data}/>
      <FooterMenu/>
      <Copyrights/>
    </footer>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js